<template>
    <div class="legal-container">
        <div class="page-header">
            <h1>隐私政策</h1>
            <el-button type="primary" @click="goBack">返回</el-button>
        </div>

        <div class="legal-content">
            <div class="update-info">
                <p><strong>更新日期：</strong>2025年1月15日</p>
                <p><strong>生效日期：</strong>2025年1月15日</p>
            </div>

            <div class="content-section">
                <h2>1. 引言</h2>
                <p>杭州启帆数字技术有限公司（以下简称"我们"）深知个人信息对您的重要性，并会尽全力保护您的个人信息安全可靠。我们致力于维持您对我们的信任，恪守以下原则，保护您的个人信息：权责一致原则、目的明确原则、选择同意原则、最少够用原则、确保安全原则、主体参与原则、公开透明原则等。</p>
                <p>本隐私政策适用于您通过启帆数字平台使用我们的产品和服务。</p>
            </div>

            <div class="content-section">
                <h2>2. 我们收集的信息</h2>
                <p><strong>2.1 您直接提供的信息</strong></p>
                <ul>
                    <li>注册信息：手机号码、邮箱地址、姓名等</li>
                    <li>认证信息：身份证号码、营业执照信息等</li>
                    <li>发布信息：您主动发布的服务信息、联系方式等</li>
                    <li>客服信息：您联系客服时提供的信息</li>
                </ul>

                <p><strong>2.2 我们自动收集的信息</strong></p>
                <ul>
                    <li>设备信息：设备型号、操作系统、浏览器类型等</li>
                    <li>日志信息：IP地址、访问时间、访问页面等</li>
                    <li>位置信息：您授权时收集的地理位置信息</li>
                    <li>Cookie信息：用于改善用户体验的技术信息</li>
                </ul>
            </div>

            <div class="content-section">
                <h2>3. 信息使用目的</h2>
                <p>我们收集和使用您的个人信息，用于以下目的：</p>
                <ul>
                    <li>提供、维护和改进我们的服务</li>
                    <li>处理您的注册、认证和服务请求</li>
                    <li>向您推送相关的服务信息和通知</li>
                    <li>进行数据分析以改善用户体验</li>
                    <li>防范和处理违法违规行为</li>
                    <li>履行法律义务和保护合法权益</li>
                </ul>
            </div>

            <div class="content-section">
                <h2>4. 信息共享与披露</h2>
                <p><strong>4.1 共享原则</strong></p>
                <p>我们不会向第三方出售、出租或以其他方式披露您的个人信息，除非：</p>
                <ul>
                    <li>获得您的明确同意</li>
                    <li>根据法律法规要求</li>
                    <li>为保护我们或他人的合法权益</li>
                    <li>与授权合作伙伴共享（仅限必要信息）</li>
                </ul>

                <p><strong>4.2 合作伙伴</strong></p>
                <p>我们可能与以下类型的合作伙伴共享必要信息：</p>
                <ul>
                    <li>技术服务提供商</li>
                    <li>数据分析服务商</li>
                    <li>支付服务提供商</li>
                    <li>客户服务提供商</li>
                </ul>
            </div>

            <div class="content-section">
                <h2>5. 信息存储与保护</h2>
                <p><strong>5.1 存储地点</strong></p>
                <p>您的个人信息将存储在中华人民共和国境内。如需跨境传输，我们将严格按照法律法规要求进行。</p>

                <p><strong>5.2 存储期限</strong></p>
                <p>我们仅在为您提供服务期间保留您的个人信息，保存期限不会超过实现目的所必需的期限。</p>

                <p><strong>5.3 安全措施</strong></p>
                <ul>
                    <li>采用加密技术保护数据传输</li>
                    <li>建立严格的数据访问权限控制</li>
                    <li>定期进行安全评估和漏洞检测</li>
                    <li>建立数据泄露应急响应机制</li>
                </ul>
            </div>

            <div class="content-section">
                <h2>6. 您的权利</h2>
                <p>根据相关法律法规，您享有以下权利：</p>
                <ul>
                    <li><strong>访问权：</strong>您有权了解我们收集、使用您个人信息的情况</li>
                    <li><strong>更正权：</strong>您有权要求我们更正不准确的个人信息</li>
                    <li><strong>删除权：</strong>在特定情况下，您有权要求我们删除您的个人信息</li>
                    <li><strong>撤回同意：</strong>您有权随时撤回您的授权同意</li>
                    <li><strong>投诉举报：</strong>您有权向监管部门投诉举报</li>
                </ul>
            </div>

            <div class="content-section">
                <h2>7. 第三方服务</h2>
                <p>我们的服务可能包含第三方链接或服务。第三方服务提供商有其独立的隐私政策，我们不对第三方的隐私政策或实践负责。建议您在使用第三方服务前仔细阅读其隐私政策。</p>
            </div>

            <div class="content-section">
                <h2>8. 未成年人保护</h2>
                <p>我们非常重视对未成年人个人信息的保护。如果您是18周岁以下的未成年人，在使用我们的服务前，应事先取得您的家长或法定监护人的同意。</p>
                <p>如果我们发现在未事先获得可证实的家长或法定监护人同意的情况下收集了未成年人的个人信息，则会设法尽快删除相关信息。</p>
            </div>

            <div class="content-section">
                <h2>9. 隐私政策的变更</h2>
                <p>我们可能会适时更新本隐私政策。当隐私政策发生变更时，我们会在网站上发布更新后的隐私政策，并通过网站公告或其他适当方式提醒您相关内容的更新。</p>
                <p>对于重大变更，我们会提供更为显著的通知（包括对于某些服务，我们会通过电子邮件发送通知，说明隐私政策的具体变更内容）。</p>
            </div>

            <div class="content-section">
                <h2>10. 联系我们</h2>
                <p>如果您对本隐私政策有任何疑问、意见或建议，请通过以下方式与我们联系：</p>
                <ul>
                    <li>邮箱：service282@163.com</li>
                    <li>客服电话：400-852-0210</li>
                    <li>地址：浙江省杭州市余杭区仓前街道景兴路999号8幢404-3室</li>
                    <li>邮编：310000</li>
                </ul>
                <p>我们将在收到您的问题后15个工作日内回复。</p>
            </div>

            <div class="footer-note">
                <p>本隐私政策自2025年1月15日起生效。我们保留在法律允许的范围内修改本政策的权利。</p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'PrivacyPolicy',
    methods: {
        goBack() {
            this.$router.go(-1);
        }
    }
}
</script>

<style scoped>
.legal-container {
    max-width: 1000px;
    margin: 0 auto;
    padding: 20px;
    background-color: #f5f5f5;
    min-height: 100vh;
}

.page-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 30px;
    padding: 20px 30px;
    background: white;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.page-header h1 {
    margin: 0;
    color: #333;
    font-size: 24px;
}

.legal-content {
    background: white;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
    padding: 40px;
    line-height: 1.8;
}

.update-info {
    background-color: #f8f9fa;
    padding: 15px 20px;
    border-radius: 6px;
    margin-bottom: 30px;
    border-left: 4px solid #52c41a;
}

.update-info p {
    margin: 5px 0;
    color: #666;
    font-size: 14px;
}

.content-section {
    margin-bottom: 30px;
}

.content-section h2 {
    color: #333;
    font-size: 18px;
    margin-bottom: 15px;
    padding-bottom: 8px;
    border-bottom: 2px solid #52c41a;
}

.content-section p {
    color: #555;
    margin-bottom: 12px;
    text-align: justify;
}

.content-section ul {
    margin: 12px 0;
    padding-left: 20px;
}

.content-section li {
    color: #555;
    margin-bottom: 8px;
}

.footer-note {
    margin-top: 40px;
    padding-top: 20px;
    border-top: 1px solid #eee;
    text-align: center;
    color: #999;
    font-size: 14px;
}

/* 响应式设计 */
@media (max-width: 768px) {
    .legal-container {
        padding: 10px;
    }

    .page-header {
        flex-direction: column;
        gap: 15px;
        text-align: center;
    }

    .legal-content {
        padding: 20px;
    }

    .page-header h1 {
        font-size: 20px;
    }
}
</style>
